import React, { VFC, useCallback } from 'react';
import { Button } from '@dxb-web-ui-framework/design-system';
import { Visibility as VisibilityIcon } from '@dxb-web-ui-framework/design-system/dist/icons';

export interface ViewRowDetailsButtonProps {
  fullWidth?: boolean;
  callback?: Function;
}

const ViewRowDetailsButton: VFC<ViewRowDetailsButtonProps> = ({ fullWidth, callback }) => {
  const onClick = useCallback(() => {
    if (callback) {
      callback();
    }
  }, [callback]);

  const calculatedFullWidth = typeof fullWidth === 'undefined' ? true : fullWidth;

  return (
    <Button
      fullWidth={calculatedFullWidth}
      data-testid='View row details'
      aria-label='View row details'
      variant='text'
      size='large'
      color='secondary'
      isIconButton={true}
      onClick={onClick}>
      <VisibilityIcon color='secondary' />
    </Button>
  );
};

export { ViewRowDetailsButton };
